// extracted by mini-css-extract-plugin
module.exports = {"apptag":"AppTag_apptag__3-xV7"};